import React from "react";
import { motion, type Variants } from "framer-motion";

interface RevealOnScrollProps {
  children: React.ReactNode;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
}

const RevealOnScroll: React.FC<RevealOnScrollProps> = ({
  children,
  delay = 0,
  direction = "up",
}) => {
  const variants: Variants = {
    hidden: {
      opacity: 0,
      y: direction === "up" ? 40 : direction === "down" ? -40 : 0,
      x: direction === "left" ? 40 : direction === "right" ? -40 : 0,
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      transition: {
        duration: 0.8,
        delay,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      // "some" = any intersection. A numeric amount (e.g. 0.2) requires that
      // fraction of the *entire* target to be visible — huge sections (platform
      // features) never hit 20% on a phone, so they stayed opacity:0 forever.
      viewport={{ once: true, amount: "some", margin: "0px 0px -32px 0px" }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default RevealOnScroll;
